<template>
  <div
    id="new-client"
    class="data-list-container vs-con-loading__container"
    v-if="config.gocheckin_feature == 1"
  >
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">New Client</span>
        </li>
      </ul>
    </div>
    <vs-table :data="clientsList">
      <template slot="thead">
        <vs-th>Campaign</vs-th>
        <vs-th class="center-title">Discount</vs-th>
        <vs-th class="center-title">Active</vs-th>
        <vs-th class="center-title">Actions</vs-th>
      </template>
      <template>
        <tbody>
          <vs-tr :data="clientsList" @click.native="editData(clientsList)" class="shadow-md">
            <vs-td>
              <p class="promotion-type font-medium truncate">{{ clientsList.campaign.name }}</p>
              <p
                class="product-name font-medium truncate"
                style="max-width: 30rem"
              >Promotion to be received upon your First Signed In.</p>
            </vs-td>
            <vs-td>
              <div class="text-center" v-if="clientsList.campaign.logic_type=='percent'">
                <p class="product-name font-medium truncate">
                  <b style="font-size:20px;">{{ clientsList.campaign.logic_value }}%</b>
                </p>
              </div>
              <div class="text-center" v-else-if="clientsList.campaign.logic_type=='usd'">
                <p class="product-name font-medium truncate">
                  <b style="font-size:20px;">${{ clientsList.campaign.logic_value }}</b>
                </p>
              </div>
              <div class="text-center" v-else>
                <p class="product-name font-medium truncate">
                  <b style="font-size:20px;">N/A</b>
                </p>
              </div>
            </vs-td>
            <vs-td>
              <div class="text-center leading-none" v-if="clientsList.campaign.is_active">
                <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-success" />
              </div>
              <div class="text-center leading-none" v-else>
                <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
              </div>
            </vs-td>
            <vs-td style="padding: 30px 20px;">
              <div class="w-full h-full flex-center">
                <vs-button
                  @click="editData(clientsList)"
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="primary"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-update-client
      :updateClientConfig="updateClientConfig"
      :sidebarData="sidebarData"
      @UpdateClient="updateClient"
      @CloseUpdateClient="closeUpdateClient"
      :key="new_client_key"
    ></vs-update-client>
  </div>
  <div v-else-if="config.gocheckin_feature == 0">
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
export default {
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data() {
    return {
      selected: [],

      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {
        campaign: {},
        campaign_report: {}
      },

      updateClientConfig: {
        isOpen: false
      },
      items: [
        {
          title: "Home",
          url: "/",
          icon: "HomeIcon"
        },
        {
          title: "New Client",
          active: true
        }
      ],
      isOpenLoading: false,
      action_type: '',
      loaded_data_num: 0,
      new_client_key: 0
    };
  },
  watch: {
  //   dataChange: {
  //     immediate: true,
  //     deep: true,
  //     handler: function () {
  //       // if(this.dataChange) {
  //       //   console.log(this.dataChange.message);
  //       // }
  //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
  //       if(this.dataChange) {
  //         this.$store.dispatch("promoList/GET_CLIENT_LIST")
  //       }
  //     },
  //   }
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    },
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.gocheckin_feature != 0 && this.config.gocheckin_feature != 1) {
    //       this.action_type = "Get data";
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
  },
  computed: {
    clientsList() {
      return this.$store.state.promoList.newClient;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update new client failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: this.action_type + " new client failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    updateClient(data) {
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("promoList/UPDATE_CLIENT", data).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update New Client Success",
          color: "success",
          position: "top-right"
        });
      });
    },
    updateActiveClient(data) {
      this.sidebarData = data;
    },
    editData(data) {
      this.new_client_key++;
      this.sidebarData = data;
      this.updateClientConfig.isOpen = true;
    },
    closeUpdateClient() {
      this.updateClientConfig.isOpen = false;
      document.getElementById("new-client").click();
    }
  },
  created() {
    // if(!moduleDataList.isRegistered) {
    //   this.$store.registerModule('dataList', moduleDataList)
    //   moduleDataList.isRegistered = true
    // }
    // this.$store.dispatch("staffList/fetchDataListItems")
    this.$store.dispatch("promoList/GET_CLIENT_LIST").then(() => {
      this.loaded_data_num++;
    });
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>
